export default "<h2>\n    SIMPLE TASK PLACEHOLDER\n</h2>\n<div>\n    <label>Task label(brief):</label><span>{{task.label}}</span>\n</div>";